"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignMessageMethods = exports.CampaignMessage = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Represents an entry in the "campaign_messages" table.
 */
var CampaignMessageMethods = /*#__PURE__*/function () {
  function CampaignMessageMethods() {
    _classCallCheck(this, CampaignMessageMethods);
  }

  _createClass(CampaignMessageMethods, null, [{
    key: "isFromMe",
    value: function isFromMe(campaignMessage) {
      return campaignMessage.created_by_user_id === null;
    }
  }, {
    key: "isCampaignMessageValid",
    value: function isCampaignMessageValid(campaignMessage) {
      return !!campaignMessage.subject && !!campaignMessage.body;
    }
  }]);

  return CampaignMessageMethods;
}();
/**
 * @deprecated - use the campaign message methods instead
 * Represents a campaign message record.
 */


exports.CampaignMessageMethods = CampaignMessageMethods;

var CampaignMessage = /*#__PURE__*/function () {
  // Used to indicate that the message is being saved
  function CampaignMessage(data) {
    _classCallCheck(this, CampaignMessage);

    _defineProperty(this, "attachment_ids", []);

    Object.assign(this, data);
  }

  _createClass(CampaignMessage, [{
    key: "isFromMe",
    value: function isFromMe() {
      return this.created_by_user_id === null || this.created_by_user_id === undefined;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return !!this.subject && !!this.body;
    }
  }]);

  return CampaignMessage;
}();
/**
 * @deprecated
 */


exports.CampaignMessage = CampaignMessage;

_defineProperty(CampaignMessage, "MessageTypes", {
  STANDARD: 'standard',
  INVITATION: 'invitation'
});